import axios from 'axios';

const baseURL = '/api';
const contactsURL = '/contacts';
const fieldAttributesURL = '/field_attributes';

/**
 * Get the contact information given an ID
 * @param contactID the id for the contact to find
 */
export const getContact = (contactID) => {
	return axios
		.get(`${baseURL}${contactsURL}/${contactID}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Updates the contact information given an ID and new contactData
 * @param contactID the id for the contact to update
 * @param contactData the new data to overwrite existing data
 */
export const putContact = (contactID, contactData) => {
	return axios
		.put(`${baseURL}${contactsURL}/${contactID}`, contactData)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Creates a new contact with the given information
 * Hits endpoint: CREATE /api/contacts
 * @param contactData the contact information
 */
export const postContact = (contactData) => {
	return axios
		.post(`${baseURL}${contactsURL}`, contactData)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Deletes a contact with the given contactID
 * Hits endpoint: DELETE /api/contacts/:id
 * @param contactID the id of the contact we want to delete
 */
export const deleteContact = (contactID) => {
	return axios
		.delete(`${baseURL}${contactsURL}/${contactID}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Gets the field attributes regarding contacts
 * Hits endpoint: GET /api/contacts/field_attributes
 */
export const getFieldAttributes = () => {
	return axios
		.get(`${baseURL}${contactsURL}/${fieldAttributesURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};
